export enum SigningStatusEnum {
    UPLOADED = 'uploaded',
    DRAFT = 'draft',
    SENT = 'sent',
    DELIVERED = 'delivered',
    VIEWED = 'viewed',
    SIGNED = 'signed',
    REVOKED = 'revoked',
    EXPIRED = 'expired',
    APPROVED = 'approved',
    UPDATED = 'updated',
    COMPLETED = 'completed',
    INVITED = 'invited',
    REJECTED = 'rejected',
    FORWARDED = 'forward',
    FAILED = 'failed',
    READONLY = 'read_only',
    WAITING = 'waiting',
    INITIATOR = 'initiator',
}

export enum AuthenticationTypeEnum {
    ESIGNATURE = 'e_signature',
    BANKID = 'bank_id',
    ESIGNANDSMSPIN = 'e_sign_and_sms_pin',
    READONLY = 'read_only',
    ATTEST = 'attest',
    NORWEGIANBANKID = 'norwegian_bank_id',
    FINNISHBANKID = 'finnish_bank_id',
    DANISHMITID = 'danish_mit_id',
}

export enum ActivityLogs {
    UPDATED = 'updated',
    OPENED = 'opened'
}